import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { savePaymentToken, setGPIError } from '../../../../Store/purchase.slice';

const { REACT_APP_GPI_TOKENIZATION_API_KEY, REACT_APP_GPI_ENVIRONMENT } = process.env;

const UseGPIPayFields = ({ setEditToken, setSaveInProgress, street, zip }) => {
  const dispatch = useDispatch();
  const [response, setResponse] = useState(null);

  useEffect(() => {
    window.GlobalPayments.configure({
      'X-GP-Api-Key': REACT_APP_GPI_TOKENIZATION_API_KEY,
      'X-GP-Environment': REACT_APP_GPI_ENVIRONMENT,
      'enableAutocomplete': true
    });

    window.GlobalPayments.on('error', error => {
      console.log(error);
      dispatch(setGPIError('GPI error'));
    });

    const cardForm = window.GlobalPayments.ui.form(GPIForm);

    cardForm.on('token-success', async response => {
      setResponse(response);
    });

    cardForm.on('token-error', response => {
      console.log(response);
      dispatch(setGPIError('GPI error'));
      setSaveInProgress(false);
    });

    cardForm.on('click', () => {
      setSaveInProgress(true);
    });
  }, []);

  useEffect(() => {
    const handleTokenSuccess = async (response) => {
      console.log(response);

      try {
        validate(street, zip);
        await dispatch(savePaymentToken({
          gpi_token: {
            token: response.temporary_token,
            street,
            zip
          },
          cardInfo: response.card
        })).unwrap();

        setEditToken(false);
        setSaveInProgress(false);
      } catch (error) {
        const errorMessage = error[0]?.message || 'GPI Error';
        dispatch(setGPIError(errorMessage));
        setSaveInProgress(false);
      }
    }

    if (response) {
      handleTokenSuccess(response);
      setResponse(null);
    }
  }, [response]);

  return <></>;
};

const validate = (street, zip) => {
  if (!street || street === '') {
    throw [Error('Street is required')];
  }

  if (!zip || zip === '') {
    throw [Error('Zip Code is required')];
  }
}

const GPIForm = {
  fields: {
    'card-number': {
      target: '#card-number-gpi',
      placeholder: '1234 1234 1234 1234'
    },
    'card-expiration': {
      target: '#card-expiration-gpi',
      placeholder: 'MM / YYYY'
    },
    'card-cvv': {
      target: '#card-cvv-gpi',
      placeholder: 'CVC'
    },
    submit: {
      target: '#submit-gpi',
      text: 'Save Credit Card'
    }
  },
  styles: {
    'input': {
      "font-size": '16px',
      "line-height": '42px',
      'background-position': '9px center',
      'background-repeat': 'no-repeat',
      'background-size': '18px 18px',
      'display': 'block',
      'height': '44px',
      'padding': '0 1em',
      'background-color': '#FFFFFF',
      'border': '1px solid #FFFFFF',
      'border-radius': '3px',
      'line-height': '44px',
    },
    'button.submit': {
      'cursor': 'pointer',
      'color': 'white',
      'background-color': '#00AEEF',
      'padding': '6px 16px',
      'font-size': '0.875rem',
      'min-width': '64px',
      'box-sizing': 'border-box',
      'font-weight': '500',
      'line-height': '1.75',
      'border-radius': '4px',
      'box-shadow': '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
      'border': '0',
      'outline': '0'
    },
    'button.submit:hover': {
      'background-color': 'rgb(0, 121, 167)'
    }
  }
}

export default UseGPIPayFields;
